import React, { FunctionComponent } from 'react';
import { ScreenshotImage } from './styled';

interface ScreenshotProps {
  imageUrl: string;
  showImage: () => {};
}

const Screenshot: FunctionComponent<ScreenshotProps> = (props) => {
  const { imageUrl, showImage } = props;

  return (
    <ScreenshotImage
      data-selenium="standardScreenshot"
      onClick={() => showImage()}
      role="button"
      initial={false}
      layoutTransition={{
        type: 'spring',
        damping: 200,
        stiffness: 100,
      }}
      thumbnail={imageUrl}
    />
  );
};

export default React.memo(Screenshot);
